import { faClose, faHandSparkles } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const OverLayButton = ({handleModel,personalizedB,color}) => {
  return (
    <div className={`personalizedB ${personalizedB && "hidden"} fixed bottom-[15%] md:bottom-[5%] right-[5%] inline-block `}
    style={{
      background:color
    }}
    >
    <button onClick={handleModel} className="text-white p-5">
      <FontAwesomeIcon className="text-2xl" icon={personalizedB?faClose:faHandSparkles}/>
    </button>
  </div>
  )
}

export default OverLayButton
